/* nineheat-policies.js — construit les tabs de langue des pages /policies.
   Chargé UNIQUEMENT quand request.page_type == 'policy' (voir layout/theme.liquid).
   Sans ce script, le CSS affiche la version française seule (fallback no-JS). */
(function () {
  'use strict';
  var LABELS = { fr: 'Français', en: 'English', es: 'Español', de: 'Deutsch', it: 'Italiano' };

  function init() {
    var roots = document.querySelectorAll('.nh-pol');
    Array.prototype.forEach.call(roots, function (root) {
      var panes = root.querySelectorAll('.nh-pol__pane');
      var codes = [];
      Array.prototype.forEach.call(panes, function (pane) {
        var match = pane.className.match(/nh-pol__pane--([a-z]{2})/);
        if (match && codes.indexOf(match[1]) === -1) codes.push(match[1]);
      });
      if (codes.length < 2) return;

      var saved = null;
      try { saved = window.localStorage.getItem('nhPolLang'); } catch (e) { /* private mode */ }
      var current = codes.indexOf(saved) > -1 ? saved : 'fr';

      var bar = document.createElement('div');
      bar.className = 'nh-pol__tabs';
      bar.setAttribute('role', 'tablist');
      bar.setAttribute('aria-label', 'Langue / Language');

      function setLang(code) {
        root.setAttribute('data-nh-lang', code);
        var tabs = bar.querySelectorAll('.nh-pol__tab');
        Array.prototype.forEach.call(tabs, function (tab) {
          var active = tab.getAttribute('data-nh-lang') === code;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        try { window.localStorage.setItem('nhPolLang', code); } catch (e) { /* noop */ }
      }

      codes.forEach(function (code) {
        var tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'nh-pol__tab';
        tab.textContent = LABELS[code] || code.toUpperCase();
        tab.setAttribute('data-nh-lang', code);
        tab.setAttribute('role', 'tab');
        tab.addEventListener('click', function () { setLang(code); });
        bar.appendChild(tab);
      });

      root.insertBefore(bar, root.firstChild);
      setLang(current);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
